import { render, staticRenderFns } from "./Fornecedor.vue?vue&type=template&id=c1b121f6&scoped=true"
import script from "./Fornecedor.vue?vue&type=script&lang=js"
export * from "./Fornecedor.vue?vue&type=script&lang=js"
import style0 from "./Fornecedor.vue?vue&type=style&index=0&id=c1b121f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b121f6",
  null
  
)

export default component.exports